<ng-template #content>
  <div [style.opacity]="disabled? 0.4 : null">
    <div fxLayout="row" fxLayoutAlign="space-between center"
         [style.visibility]="loading ? 'hidden' : 'visible'">
      <div style="position: relative;">
        <app-icon *ngIf="url;" [name]="'open_in_new'"
                  style=" position: absolute;  top: -6px;  left: 0; " [color]="'#B3B3B3'"
                  [width]="12" [height]="12"></app-icon>
        <h1 class="primary-color" [style]="titleStyle">{{ title }}</h1>
      </div
      >

      <app-icon [width]="iconSize" [height]="iconSize" class="accent-color" [name]="icon"></app-icon>
    </div>

    <div [ngClass]="['loader']" *ngIf="loading">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </div>
</ng-template>

<div class="flex ">
  <button mat-button
          [attr.aria-label]="title"
          [style.width]="customWidth"
          [style.padding]="customPadding"
          [style.height]="customHeight? customHeight: null"
          [disabled]="disabled"
          (click)="onClick()">
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </button>
</div>
